import { render, staticRenderFns } from "./CoursewareWelcomeScreen.vue?vue&type=template&id=7d620956&"
import script from "./CoursewareWelcomeScreen.vue?vue&type=script&lang=js&"
export * from "./CoursewareWelcomeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports